((d) => {
    var
        ce = (e, n) => {
            var a = document.createEvent("CustomEvent");
            a.initCustomEvent(n, true, true, e.target);
            e.target.dispatchEvent(a);
            a = null;
            return false
        },
        nm = true,
        sp = {
            x: 0,
            y: 0
        },
        ep = {
            x: 0,
            y: 0
        },
        touch = {
            touchstart: (e) => {
                sp = {
                    x: e.touches[0].pageX,
                    y: e.touches[0].pageY
                }
            },
            touchmove: (e) => {
                nm = false;
                ep = {
                    x: e.touches[0].pageX,
                    y: e.touches[0].pageY
                }
            },
            touchend: (e) => {
                if (nm) {
                    ce(e, 'fc')
                } else {
                    var x = ep.x - sp.x,
                        xr = Math.abs(x),
                        y = ep.y - sp.y,
                        yr = Math.abs(y);
                    if (Math.max(xr, yr) > 20) {
                        ce(e, (xr > yr ? (x < 0 ? 'swl' : 'swr') : (y < 0 ? 'swu' : 'swd')))
                    }
                };
                nm = true
            },
            touchcancel: (e) => {
                nm = false
            }
        };
    for (var a in touch) {
        d.addEventListener(a, touch[a], false);
    }
})(document);

const wheelHandler = (e) => {
    return typeof e.wheelDelta != 'undefined' ? (e.wheelDelta < 0 ? true : false) : (e.detail < 0 ? false : true);
}

const wheelDragDirection = (event) => {
    var direction = "down";
    switch (event.type) {
        case "mousewheel":
            direction = wheelHandler(event) ? "down" : "up";
            break;
        case "swu":
            direction = "down";
            break;
        case "swd":
            direction = "up";
            break;
    }
    return direction;
}

window.addEventListener('load', function () {
    var preventPullToRefreshCheckbox = true;
    var preventOverscrollGlowCheckbox = false;
    var preventScrollCheckbox = false;

    var maybePreventPullToRefresh = false;
    var lastTouchY = 0;
    var touchstartHandler = function (e) {
        if (e.touches.length != 1) return;
        lastTouchY = e.touches[0].clientY;
        // Pull-to-refresh will only trigger if the scroll begins when the
        // document's Y offset is zero.
        maybePreventPullToRefresh =
            preventPullToRefreshCheckbox &&
            window.pageYOffset == 0;
    }

    var touchmoveHandler = function (e) {
        var touchY = e.touches[0].clientY;
        var touchYDelta = touchY - lastTouchY;
        lastTouchY = touchY;

        if (maybePreventPullToRefresh) {
            // To suppress pull-to-refresh it is sufficient to preventDefault the
            // first overscrolling touchmove.
            maybePreventPullToRefresh = false;
            if (touchYDelta > 0) {
                e.preventDefault();
                return;
            }
        }

        if (preventScrollCheckbox) {
            e.preventDefault();
            return;
        }

        if (preventOverscrollGlowCheckbox) {
            if (window.pageYOffset == 0 && touchYDelta > 0) {
                e.preventDefault();
                return;
            }
        }
    }

    window.document.addEventListener('touchstart', touchstartHandler, {
        passive: false
    });
    window.document.addEventListener('touchmove', touchmoveHandler, {
        passive: false
    });
});




export {
    wheelHandler,
    wheelDragDirection
}


// WEBPACK FOOTER //
// ./src/Components/Services/SwipeEvents.js